class Accordion {

    // 1. Initiate Accordion object
    constructor() {
        this.trademarkLinks = document.querySelectorAll(".accordion");
        this.events();
    }

    // 2. Event handlers
    events() {
        this.trademarkLinks.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                this.rotateAngle(el);
                this.toggleContent(el);
            });
        });
    }

    // 3. Methods

    // Change angle direction
    rotateAngle(element) {
        let icon = element.querySelector(".icon");
        icon.classList.toggle("icon--down");
    }

    // Toggle content from hidden to visible
    toggleContent(element) {
        let trademarkList = element.querySelector(".tavaramerkkilistaus");
        trademarkList.classList.toggle("hidden");
    }
}

let accordion = new Accordion();
